var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardIconPlus(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0423 16.6237V11.8737M12.6673 14.2487H17.4173M17.4173 7.91536H1.58398M17.4173 9.4987V6.49037C17.4173 5.60362 17.4173 5.16024 17.2447 4.82155C17.0929 4.52362 16.8507 4.28141 16.5528 4.12961C16.2141 3.95703 15.7707 3.95703 14.884 3.95703H4.11732C3.23057 3.95703 2.78719 3.95703 2.4485 4.1296C2.15058 4.2814 1.90836 4.52362 1.75656 4.82155C1.58398 5.16024 1.58398 5.60361 1.58398 6.49036V12.507C1.58398 13.3938 1.58398 13.8372 1.75656 14.1758C1.90836 14.4738 2.15058 14.716 2.4485 14.8678C2.78719 15.0404 3.23057 15.0404 4.11732 15.0404H9.50065",
    stroke: "white",
    strokeWidth: 1.58333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIconPlus);
export default __webpack_public_path__ + "static/media/card-icon-plus.f51b6e9343ef60ef3648b27b6897b9d7.svg";
export { ForwardRef as ReactComponent };